import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import * as s from './ItemCreator.module.scss'

const ItemCreator = (props) => {
  const { node, avatarImg, title, subs, variant, className, ...rest } = props

  return (
    <div
      {...rest}
      className={cn(s.itemCreator, { [s[variant]]: variant }, className)}
    >
      <img src={`/avatars/${avatarImg}`} className={s.imgAvatar} alt={title} />
      <span className={s.textName}>{title}</span>
      <span className={s.textSubs}>{subs}</span>
    </div>
  )
}

ItemCreator.defaultProps = {
  variant: '',
  className: undefined,
  avatarImg: undefined,
  node: undefined,
}

ItemCreator.propTypes = {
  title: PropTypes.string.isRequired,
  subs: PropTypes.string.isRequired,
  node: PropTypes.object,
  avatarImg: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.string,
}

export default ItemCreator
